import { Component, inject } from '@angular/core';
import { NgOptimizedImage } from '@angular/common';
import { RouterLink } from '@angular/router';
import { TranslatePipe } from '@ngx-translate/core';
import { StyleClass } from 'primeng/styleclass';
import { LayoutService } from '../../../services';
import { ProfileComponent } from '../../profile/profile.component';

@Component({
  selector: 'rb-topbar',
  imports: [TranslatePipe, NgOptimizedImage, RouterLink, StyleClass, ProfileComponent],
  templateUrl: './topbar.component.html',
  styleUrl: './topbar.component.scss',
})
export class TopbarComponent {
  layoutService: LayoutService = inject(LayoutService);
}
